import styled from 'styled-components'
/**
 * Styled component is used to decorate StoreBanner component.
 * Props are passed from ThemeProvider component.
 */
export const StoreBannerStyle = styled.div`
  background-color: ${(props) =>
    props.theme.banner?.backgroundColor || '#6300AA'};
  display: flex;
  width: -webkit-fill-available;
  width: -moz-available;
  align-items: center;
  color: ${(props) => props.theme.banner?.color || 'white'} !important;
  font-family: ${(props) => props.theme.banner?.fontFamily};
  ${(props) =>
    props.theme.banner?.logoPosition === 'right' &&
    `flex-direction: row-reverse;`}
  ${(props) =>
    props.theme.banner?.logoPosition === 'left' && `flex-direction: row;`}
  ${(props) =>
    props.theme.banner?.logoPosition === 'center' && `flex-direction: column;`}
  p {
    width: 100%;
    font-size: ${(props) => props.theme.banner?.fontSize}rem;
    // text-align: center;
  }
  img {
    padding: 0 1em;
  }
  padding: 0.6rem 0 0.6rem 0;
`
